// extracted by mini-css-extract-plugin
export default {"row":"nJdhs","textNoMargin":"W0LxK","textLineHeight":"_5pEbm","preWrap":"j5iBw","ellipsis":"D2vk2"};